import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 15.8 14.9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.8 14.9\" id=\"search\"><path d=\"M15 14.9l-4.8-4.6C9.1 11.4 7.6 12 6 12c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6c0 1.3-.4 2.5-1.1 3.4l4.8 4.7-.7.8zM6 1.1C3.3 1.1 1.1 3.3 1.1 6s2.2 4.9 4.9 4.9 4.9-2.2 4.9-4.9S8.7 1.1 6 1.1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol